/**
 * 前端多语言解决方案
 */
import _ from 'underscore';
import url from 'c-url';
import $ from 'jquery';

let _lang = {

    init: function (LangPack) {
        let lang = this.getLanguage();
        let langType = lang.replace('-', '').toLowerCase();
        let platform = this.getPlatform();

        $('html').attr('lang', lang);
        $('body').addClass(langType);

        (platform == 6666) && $('body').addClass('haya');

        this.lang = lang;
        this.pack = LangPack;
        this.langType = langType;
        this.platform = platform;
    },
    getLanguage: function () {
        return url.query('lang') || 'en-US';
    },
    getPlatform: function () {
        return url.query('feature') || 'uplive';
    },
    hasTemplate: function (tplStr) {
        let langPack = this.pack;
        return !!langPack[tplStr]
    },
    template: function (tplStr, data, insertEM) {

        let lang = url.query('lang') || 'en-US';
        let langType = this.langType;
        let langPack = this.pack;
        let tpl = (langPack[tplStr] || tplStr) + '';
        try {
            if (tpl) {
                if (tpl.indexOf('@@@@') >= 0) {
                    let strArr = [];
                    strArr.push('<ul>');
                    tpl.split('@@@@').forEach(function (item, index) {
                        item && strArr.push('<li>' + item + '</li>');
                    });
                    strArr.push('</ul>');
                    tpl = strArr.join('');
                }
                if (insertEM) {
                    tpl = tpl.replace(/<%=([\s\S]+?)%>/g, function ($0, $1) {
                        return '<em class="' + $1 + '">' + $0 + '</em>';
                    });
                }
                //Uplive字段替换成Haya用于声播项目，标识为URL上带feature=6666
                if (this.platform == 6666) {
                    tpl = tpl.replace(/Uplive/ig, 'Haya');
                }
                if (this.platform == 777) {
                    tpl = tpl.replace(/Uplive/ig, 'Bubbly');
                }
                if (this.platform == 10001) {
                    tpl = tpl.replace(/Uplive/ig, 'Uparty');
                }
                let compiled = _.template(tpl);

                console.log('compiled: ', compiled(data));
                return compiled(data);

            } else {
                return _.template(tplStr)(data);
            }
        } catch (e) {
            console.log(e.message);
        }
    }
};

module.exports = _lang;



// WEBPACK FOOTER //
// ./js/lang/index.js